// extracted by mini-css-extract-plugin
export default {"scc__poweredup__container":"PoweredUp_scc__poweredup__container__64WSx","scc__poweredup__form":"PoweredUp_scc__poweredup__form__EVpN9"};